<template>
    <b-row class="mt-5">
      <b-col cols="12">
        <b-alert show variant="warning" class="p-2 p-lg-3 font-weight-bold text-center">
          <i class="fa fa-product-hunt"/>  {{ selectedGraficas.productos }} Productos caracterizados
        </b-alert>
      </b-col>


        <b-col sm="6"
               lg="4"
        >
            <b-card header="SGA"
                    no-body
                    class="pb-2"
            >
                <div class="chart-wrapper">
                    <Sga :productos.sync="selectedGraficas.productos"
                         :conSga.sync="selectedGraficas.conSga"
                         :sinSga.sync="selectedGraficas.sinSga"
                         :cambia.sync="selectedGraficas.cambia"
                    />
                </div>
            </b-card>
            <b-card no-body
                    class="bg-primary p-3"
            >
                <h4 class="mb-0">Total de Productos : {{ selectedGraficas.productos }}</h4>
                <br>
                <h6 class="mb-0">Con SGA : {{ selectedGraficas.conSga }}</h6>
                <h6 class="mb-0">Sin SGA : {{ selectedGraficas.sinSga }}</h6>
            </b-card>
        </b-col>
        <b-col sm="6"
               lg="4"
        >
            <b-card header="NACIONES UNIDAS"
                    no-body
                    class="pb-2"
            >
                <div class="chart-wrapper">
                    <Un :productos.sync="selectedGraficas.productos"
                        :conUn.sync="selectedGraficas.conUn"
                        :sinUn.sync="selectedGraficas.sinUn"
                        :cambia.sync="selectedGraficas.cambia"
                    />
                </div>
                <!-- <DatosGraficas :datos="datos"></DatosGraficas> -->
            </b-card>
            <b-card no-body
                    class="bg-primary p-3"
            >
                <h4 class="mb-0">Total de Productos : {{ selectedGraficas.productos }}</h4>
                <br>
                <h6 class="mb-0">Con UN : {{ selectedGraficas.conUn }}</h6>
                <h6 class="mb-0">Sin UN : {{ selectedGraficas.sinUn }}</h6>
            </b-card>
        </b-col>
        <b-col sm="6"
               lg="4"
        >
            <b-card header="FDS/MSDS"
                    no-body
                    class="pb-2"
            >
                <div class="chart-wrapper">
                    <Fds :porc_con_FDS.sync="selectedGraficasFdsMsds.porc_con_FDS"
                         :porc_con_MSDS.sync="selectedGraficasFdsMsds.porc_con_MSDS"
                         :porc_sin_Adj.sync="selectedGraficasFdsMsds.porc_sin_Adj"
                         :cambia.sync="selectedGraficasFdsMsds.cambia"
                    />
                </div>
                <!-- <DatosGraficas :datos="datosDocumentos"></DatosGraficas> -->
            </b-card>
            <b-card no-body
                    class="bg-primary p-3"
            >
                <h4 class="mb-0">Total de Productos : {{ selectedGraficasFdsMsds.productos }}</h4>
                <br>
                <h6 class="mb-0">Con FDS : {{ selectedGraficasFdsMsds.conFDS }}</h6>
                <h6 class="mb-0">Con MSDS : {{ selectedGraficasFdsMsds.conMSDS }}</h6>
                <h6 class="mb-0">Sin Adjunto : {{ selectedGraficasFdsMsds.sinAdj }}</h6>
            </b-card>
        </b-col>
    </b-row>

</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {getAcls} from '../../plugins/acl';
import Nfpa from './Nfpa';
import Sga from './Sga';
import Un from './Un';
import Fds from './Fds';
import DatosGraficas from './DatosGraficas';

export default {
    name: 'Graficas',
    components: {
        Nfpa,
        Sga,
        Un,
        Fds,
        DatosGraficas
    },
    created() {

    },
    data() {
        return {
            datos: [
                {titulos: ['Si', 'No'], 'Si': 55, 'No': 45},
            ],
            datosDocumentos: [
                {titulos: ['FDS', 'MSDS', 'Sin Documento'], 'FDS': 45, 'MSDS': 35, 'Sin Documento': 20},
            ]
        };
    },
    computed: {
        ...mapState('dashboard', [
            'selectedGraficas',
            'selectedGraficasFdsMsds'
        ]),
    }
};
</script>
